import { DirectiveOptions } from 'vue';
import { moment } from '../app.config';

const dateFormat: DirectiveOptions = {
    inserted(el, { value: { date = null, inputFormat = 'YYYY-MM-DD', outputFormat = 'YYYY-MM-DD' } }): void {
        if (!date || !inputFormat || !outputFormat) {
            return;
        }

        const outputDate: moment.Moment = moment(date, inputFormat, true);

        if (!outputDate.isValid()) {
            return;
        }

        el.innerText = outputDate.format(outputFormat);
    },
};

export default dateFormat;
